import { default as domainTeacherIndicator } from './indicator/services'
import { default as teacherPositionCategory } from './position-category/services'
import { default as domainActivityOfferedComponent } from './activity-offered-component/services'
import { default as domainActivityOfferedModality } from './activity-offered-modality/services'
import { default as domainActivityOffered } from './activity-offered/services'

export default {
	domainTeacherIndicator,
	teacherPositionCategory,
	domainActivityOfferedComponent,
	domainActivityOfferedModality,
	domainActivityOffered
}